// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hc-ui .person_add_contact_form--field_set .ui.divider{visibility:hidden}.hc-ui .person_add_contact_form--field_set .form--fieldset_title_column{padding-bottom:5px !important}.hc-ui .person_add_contact_form--field_legend{line-height:20px;padding-top:0 !important}\n", ""]);
// Exports
module.exports = exports;
